/**
 * dispararDescarga fuerza la descarga en el navegador de un Blob con el nombre dado. Se
 * apoya en un enlace temporal con una object URL, que se revoca en cuanto se dispara la
 * descarga para no filtrar memoria; el enlace no queda montado en el DOM.
 *
 * Vive en su propio módulo (#253) porque lo comparten las dos direcciones del intercambio de
 * ficheros: las exportaciones (`lib/export.ts`) y la plantilla de importación
 * (`lib/import.ts`). Es el ÚNICO sitio del SPA que compone la descarga: duplicarlo haría que
 * una de las dos se quedara sin la revocación de la URL o sin el nombre del servidor.
 */
export function dispararDescarga(blob: Blob, nombreArchivo: string): void {
  const url = URL.createObjectURL(blob);
  try {
    const enlace = document.createElement("a");
    enlace.href = url;
    enlace.download = nombreArchivo;
    document.body.appendChild(enlace);
    enlace.click();
    enlace.remove();
  } finally {
    URL.revokeObjectURL(url);
  }
}
